import { Map } from "immutable";
import { getDefaultPath } from "../../helpers/urlSync";
import actions from "./actions";

const preKeys = getDefaultPath();

const initState = new Map({
  referenceImages: [],
  selectedReferenceImage: {},
  pages: 0,
  totalRecords: 0,
  currentPage: 1,
  currentPageSize: 10,
  siteList: [],
  cameraList: []
});

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_REFERENCE_IMAGES:
      return state
        .set("referenceImages", action.dataArray)
        .set("pages", action.pages)
        .set("totalRecords", action.totalRecords)
        .set("currentPage", action.currentPage)
        .set("currentPageSize", action.currentPageSize);
    case actions.VIEW_REFERENCE_IMAGE:
      return state.set("selectedReferenceImage", action.data);
    case actions.LOAD_SITE_LIST:
      return state.set("siteList", action.dataArray);
    case actions.LOAD_CAMERA_LIST:
        return state.set("cameraList", action.dataArray);
    default:
      return state;
  }
}
